import { css } from "@emotion/react";
import { colors } from "./colors";
import { font } from "./font";

export const theme = {
  colors,
  font,
  spacing: (factor: number) => `${factor * 8}px`,
};

export const globalStyles = css`
  * {
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
  }

  body {
    margin: 0;
    padding: 0;
    font-family: ${theme.font.body.fontFamily} -apple-system, Arial, sans-serif;
    background-color: ${theme.colors.primary["primary/dark"]};
    color: ${theme.colors.text["text/100%"]};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin: auto;
    width: 100%;
  }

  html {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  ::-webkit-scrollbar {
    display: none;
    width: 8px;
    background-color: #0c1a3d;
  }

  ::-webkit-scrollbar-thumb {
    background: #3f0ee6;
    border-radius: 8px;
  }
`;
